import { useMemo, useState, useEffect, useCallback } from 'react';
import { throttle } from 'underscore';
import { prop } from 'js/utils/ramda.util';
import { useDeviceSelector } from 'js/store/hooks';
import { useIsMounted } from 'js/hooks/useIsMounted';
import ResizeObserver from 'resize-observer-polyfill';

export const useCommonTableWidthObserver = (tableRef, threshold) => {
    const isMounted = useIsMounted();
    const isMobile = useDeviceSelector(prop('isMobile'));
    const [isForcedAccordionView, setForcedAccordionView] = useState(false);

    const toggleForcedAccordionView = useCallback((tableEl) => {
        if (!isMounted()) {
            return;
        }

        setForcedAccordionView(tableEl.clientWidth < threshold);
    }, [isMounted, setForcedAccordionView, threshold]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onResize = useCallback(
        throttle(([entry]) => toggleForcedAccordionView(entry.target), 500),
        [toggleForcedAccordionView]
    );

    useEffect(() => {
        if (isMobile) {
            return;
        }

        const tableEl = tableRef.current;
        const resizeObserver = new ResizeObserver(onResize);

        resizeObserver.observe(tableEl);
        toggleForcedAccordionView(tableEl);

        return () => resizeObserver.unobserve(tableEl);
    }, [isMobile, toggleForcedAccordionView, onResize, tableRef]);

    return useMemo(() => isForcedAccordionView, [isForcedAccordionView]);
};
